export function removeHashAndValue(text: string, replaceWith: string = "") {
  if (!text) return;
  return text.replace(/#.*$/, replaceWith);
}

export function makeHtmlIdSafe(text: string): string {
  if (!text) return "";
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9-]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function stripHTML(text: string, replaceWith: string = ""): string {
  if (!text) return "";

  // Replace tags with given string
  let stripped = text.replace(/<\/?[^>]+(>|$)/g, replaceWith);

  // Normalize whitespace: collapse multiple spaces/tabs/newlines into one space
  stripped = stripped.replace(/\s+/g, " ").trim();

  return stripped;
}
